import {createSelector} from "reselect";
import {useSelector} from "react-redux";

import {IAppStore} from "../types/IAppStore";


const selectorGuestmeNotifications = createSelector(
  [(store: IAppStore) => store],
  store => store.guestmeNotifications,
);

export function useRestaurantGuestmeNotifications(restaurantId: number) {
  const {restaurants} = useSelector(selectorGuestmeNotifications);
  return restaurants[restaurantId];
}

export function useIsWhatsappLoading() {
  const {whatsappIsLoading} = useSelector(selectorGuestmeNotifications);
  return whatsappIsLoading;
}

export function useIsWhatsappResetLoading() {
  const {whatsappResetIsLoading} = useSelector(selectorGuestmeNotifications);
  return whatsappResetIsLoading;
}

export function useIsTgResetLoading() {
  const {tgResetIsLoading} = useSelector(selectorGuestmeNotifications);
  return tgResetIsLoading;
}

export function useIsTgPhoneLoading() {
  const {tgPhoneIsLoading} = useSelector(selectorGuestmeNotifications);
  return tgPhoneIsLoading;
}

export function useIsTgCodeLoading() {
  const {tgCodeIsLoading} = useSelector(selectorGuestmeNotifications);
  return tgCodeIsLoading;
}

export function useIsTgPasswordLoading() {
  const {tgPasswordIsLoading} = useSelector(selectorGuestmeNotifications);
  return tgPasswordIsLoading;
}
